import styled from "styled-components"
import * as designConstants from "app/static/frontend/design-constants"

export const Attachment = styled.div`
    display: flex;
    align-items: center;
    color: ${designConstants.QuorumGrey4};

    span {
        margin: 0 7px;
        font-size: 14px;
        font-weight: 400;
        text-decoration: underline;
    }

    svg:last-of-type {
        font-size: 1.2em;
        cursor: pointer;
    }
`

export const AttachmentButton = styled.label`
    cursor: pointer;
    align-self: flex-end;

    color: ${designConstants.QuorumBlue};
    :hover {
        color: ${designConstants.CloudBurst};
    }

    font-size: 16px;
    font-weight: 400;

    svg {
        margin-right: 6px;
    }
`

export const Input = styled.input`
    /* Using opacity: 0 ensures compatibility with assistive technology */
    opacity: 0;
    width: 0;
    height: 0;
`
